import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Landing.css";

const Landing = () => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="landing-container">
      <div className="landing-hero">
        <div className="hero-content">
          <div className="logo-container">
            <div className="logo-icon">
              <svg viewBox="0 0 24 24" fill="currentColor" className="logo-music">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-3 5-3v6zm7 0l-5-3 5-3v6z"/>
              </svg>
            </div>
            <h1 className="logo-text">Sama Music</h1>
          </div>
          
          <p className="hero-tagline">Your music, your way</p>
          <p className="hero-description">
            Stream unlimited songs, create playlists, and discover new artists. 
            Experience music like never before.
          </p>
          
          <button 
            className={`cta-button ${isHovered ? 'hovered' : ''}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => navigate("/login")}
          >
            <span>Get Started</span>
            <svg viewBox="0 0 24 24" fill="currentColor" className="arrow-icon">
              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
            </svg>
          </button>
        </div>
        
        <div className="hero-visual">
          <div className="floating-cards">
            <div className="card card-1">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/></svg>
              </div>
              <span>Unlimited Music</span>
            </div>
            <div className="card card-2">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM10 9h8v2h-8zm0 3h4v2h-4z"/></svg>
              </div>
              <span>Create Playlists</span>
            </div>
            <div className="card card-3">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
              </div>
              <span>Discover Artists</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="features-section">
        <h2 className="features-title">Why Choose Sama Music?</h2>
        <div className="features-grid">
          <div className="feature-item">
            <div className="feature-icon gradient-1">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/></svg>
            </div>
            <h3>High Quality Audio</h3>
            <p>Experience crystal clear sound with our premium audio streaming</p>
          </div>
          
          <div className="feature-item">
            <div className="feature-icon gradient-2">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"/></svg>
            </div>
            <h3>Personal Playlists</h3>
            <p>Create and manage your own music collections effortlessly</p>
          </div>
          
          <div className="feature-item">
            <div className="feature-icon gradient-3">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
            </div>
            <h3>Discover New Music</h3>
            <p>Find new artists and songs tailored to your taste</p>
          </div>
          
          <div className="feature-item">
            <div className="feature-icon gradient-4">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM9 8l5 4-5 4V8z"/></svg>
            </div>
            <h3>Offline Listening</h3>
            <p>Download your favorite songs and listen anywhere</p>
          </div>
        </div>
      </div>
      
      <div className="footer">
        <p>&copy; 2024 Sama Music. All rights reserved.</p>
        <div className="footer-links">
          <a href="/privacy-policy">Privacy</a>
          <a href="/terms-conditions">Terms</a>
          <a href="/contact">Contact</a>
        </div>
      </div>
    </div>
  );
};

export default Landing;